import { isString } from "antd/es/button";
import { redirect } from "react-router-dom";

class Authorization {
  authUser = null;
  token = null;

  constructor() {
    this.authUser = null;
    this.token = null;
  }

  // set auth user details to class property
  setAuthUser() {
    this.authUser = JSON.parse(sessionStorage.getItem("userDetails") || "{}");
  }

  isLoggedIn() {
    return typeof sessionStorage.getItem("userDetails") === "string";
  }

  login(userDetails) {
    if (typeof Storage !== undefined) {
      sessionStorage.setItem("userDetails", JSON.stringify(userDetails));
    } else {
      console.error("local storage is not supported");
    }
  }

  logout() {
    sessionStorage.removeItem("userDetails");
  }

  getAuthUser() {
    if (this.isLoggedIn()) {
      this.setAuthUser();
    }
    return this.authUser;
  }

  getAccessToken() {
    let accessToken = null;
    const authUser = this.getAuthUser();
    if (authUser && isString(authUser.token)) {
      accessToken = authUser.token;
    }

    return accessToken;
  }
}

export default new Authorization();
